module.exports = __webpack_public_path__ + "img/1.4e18187e.png";